// extracted by mini-css-extract-plugin
export default {"link":"SettingsPersonalInfoEmail_link__TzF9Z","linkIcon":"SettingsPersonalInfoEmail_linkIcon__ENjsi"};